import React, { useCallback, useMemo, useRef } from "react";
import { read as asyncStorageRead, write as asyncStorageWrite, baseBootstrap, } from "@lookiero/i18n";
import { QueryStatus, bootstrap as messagingReactBootstrap, } from "@lookiero/messaging-react";
import { useSyncTranslationForLocale } from "./behaviors/useSyncTranslationForLocale";
import { useViewTranslationForLocale } from "./behaviors/useViewTranslationForLocale";
const I18nConsumer = ({ domain, locale, children }) => {
    const [translation, viewStatus] = useViewTranslationForLocale({
        locale,
        contextId: domain,
    });
    const { status: syncStatus, isLocaleSynced } = useSyncTranslationForLocale({
        locale,
        contextId: domain,
    });
    // Assigned during render, not in a `useEffect`: an effect lags one commit, and
    // `isTranslationReady` must read the status in effect for the current render.
    const viewStatusRef = useRef(viewStatus);
    viewStatusRef.current = viewStatus;
    const isTranslationReady = useCallback((candidate) => isLocaleSynced(candidate) &&
        viewStatusRef.current !== QueryStatus.LOADING, [isLocaleSynced]);
    const value = useMemo(() => ({ locale, translation, syncStatus, isTranslationReady }), [locale, translation, syncStatus, isTranslationReady]);
    return children(value);
};
const i18nRoot = ({ fetchTranslation, read = asyncStorageRead, write = asyncStorageWrite, domain, }) => {
    const { Component: Messaging } = baseBootstrap({
        messaging: messagingReactBootstrap({ id: domain }),
        domain,
    })({
        fetchTranslation,
        read,
        write,
    });
    // eslint-disable-next-line react/display-name, react/prop-types
    return ({ locale, children, includeDevTools }) => (React.createElement(Messaging, { cacheClearOnUnmount: false, includeReactQueryDevTools: includeDevTools },
        React.createElement(I18nConsumer, { domain: domain, locale: locale }, (value) => children(value))));
};
export { i18nRoot };
